"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amb = _interopRequireDefault(require("./amb.Logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SessionExtension = function SessionExtension() {
  var LOGGER = new _amb.default('amb.SessionExtension');
  var META_CONNECT = '/meta/connect';
  var extendSession = false;

  this.extendSession = function () {
    extendSession = true;
  };

  this.outgoing = function (message) {
    if (message.channel === META_CONNECT && extendSession) {
      if (!message.ext) message.ext = {};
      LOGGER.debug('extendSession');
      message.ext.extendSession = true;
      extendSession = false;
    }

    return message;
  };
};

var _default = SessionExtension;
exports.default = _default;